export const getConversionMap = state => state.conversion

export const getConversionBySuAndCode = (state, su, code, list = undefined) => {
	const conversion = state ? getConversionMap(state) : list

	return conversion && conversion[su] && conversion[su][code]
}

